import './css/style.css';
import './images/arrow.svg';
import { initCollapsibles } from './js/collapsible';

// Инициализация после загрузки DOM
document.addEventListener('DOMContentLoaded', () => {
    initCollapsibles();

    // Добавляем демонстрационную кнопку для создания нового collapsible элемента
    const container = document.querySelector('.collapsible-container');

    const addButton = document.createElement('button');
    addButton.textContent = 'Добавить новый контейнер';
    addButton.style.cssText = `
        display: block;
        margin: 20px auto 0;
        padding: 10px 20px;
        background: #3498db;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        transition: background 0.3s;
    `;

    addButton.addEventListener('mouseenter', () => {
        addButton.style.background = '#2980b9';
    });

    addButton.addEventListener('mouseleave', () => {
        addButton.style.background = '#3498db';
    });

    addButton.addEventListener('click', () => {
        const newCollapsible = document.createElement('div');
        newCollapsible.className = 'collapsible';
        newCollapsible.innerHTML = `
            <button class="collapsible__trigger">
                <span class="collapsible__title">Новый контейнер</span>
                <img src="./images/arrow.svg" alt="arrow" class="collapsible__arrow">
            </button>
            <div class="collapsible__content">
                <div class="collapsible__content-inner">
                    <p>Это новый динамически созданный collapsible контейнер. Он работает точно так же, как и остальные.</p>
                    <p>Добавлен: ${new Date().toLocaleString()}</p>
                </div>
            </div>
        `;

        container.appendChild(newCollapsible);

        // Инициализируем новый collapsible элемент
        import('./js/collapsible').then(module => {
            new module.default(newCollapsible);
        });
    });

    container.appendChild(addButton);
});

// Для разработки с горячей перезагрузкой
if (module.hot) {
    module.hot.accept();
}